import { Box } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { useCurrencySymbol } from "Hooks/useCurrencySymbol";

type Props = {
  currency: string;
  /** Diameter in px. */
  size: number;
  /** "light" = white disc with dark symbol (on the hero); "dark" = dark disc with white symbol (in the sheet). */
  colorVariant: "light" | "dark";
};

/** A round disc with the currency symbol — the pill's and the sheet rows' currency mark. */
export const CurrencyBadge = ({ currency, size, colorVariant }: Props) => {
  const symbol = useCurrencySymbol(currency);

  return (
    <Box
      width={size}
      height={size}
      borderRadius="50%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      fontWeight={700}
      fontSize={size * 0.4}
      bgcolor={colorVariant === "light" ? "common.white" : Colors.SpaceBlack}
      color={colorVariant === "light" ? Colors.SpaceBlack : "common.white"}
    >
      {symbol}
    </Box>
  );
};
